"use strict";
exports.__esModule = true;
exports.chart_color_blue_400 = {
  "name": "--pf-v5-chart-color-blue-400",
  "value": "#004b95",
  "var": "var(--pf-v5-chart-color-blue-400, #004b95)"
};
exports["default"] = exports.chart_color_blue_400;